import React, { useState } from 'react';
import './Navbar.css';

import { Link } from "react-router-dom";

function SiteNavbar() {
    const [showLinks, setShowLinks] = useState(false);

    return (
        <div className="Navbar">
            <div className="leftSide">
                <div className="links"  id={showLinks ? "hidden" : "" }>
                    <Link to='/'>Overview</Link>
                    <Link to='/outline'>Course Description</ Link>
                    <Link to='/projects'>Projects</Link>
                    <Link to='/sponsors'>Sponsor Us</Link>
                    <Link to='/contactus'>Faculty</Link>
                </div>
            </div>
            <div className="rightSide">
                <div className="links">
                    <Link to='/Login'><button id = "portalbutton" >Senior Design Portal</button></Link>
                </div>
                <div className="container" id={showLinks ? "change" : ""} onClick={()=>{setShowLinks(!showLinks)}}>
                    <div className="bar1"></div>
                    <div className="bar2"></div>
                    <div className="bar3"></div>
                </div>

            </div>
        </div>
    )
}

export default SiteNavbar;
